module.exports = __webpack_public_path__ + "static/media/hand-holding-box.0bb69335.svg";